/* eslint-disable complexity */
import { HYDRATE } from 'next-redux-wrapper';

import { EConnectionType } from '@r1-frontend/api-domru/api-profile/v1/services-settings/connection-type';
import { IIpAddressItem as ServiceSettingsIp } from '@r1-frontend/api-domru/api-profile/v1/services-settings/get-ip-list';
import { EIPv6Status } from '@r1-frontend/api-domru/api-profile/v1/services-settings/get-ipv6-status';
import {
    ResponseDto as ISocialAccessData,
} from '@r1-frontend/api-domru/api-profile/v1/services-settings/get-social-access-info';
import { IIpPrice } from '@r1-frontend/api-domru/api-profile/v1/services-settings/ip-price';
import { ESmtpBlockState } from '@r1-frontend/api-domru/api-profile/v1/services-settings/smtp-allowed-value';
import { IStatistic } from '@r1-frontend/api-domru/api-profile/v1/services-settings/statistic';

import { InferValueTypes, THydrateAction } from '~/src/store';
import * as ActionCreators from '~/src/store/actionCreators/serviceSettings';
import { IPtrZones } from '~/src/store/actions/serviceSettings';
import {
    ADD_SOCIAL_ACCESS_ERROR,
    ADD_SOCIAL_ACCESS_LOADED,
    ADD_SOCIAL_ACCESS_LOADING,
    CONNECTION_TYPE_LOADED,
    CONNECTION_TYPE_LOADING,
    IP_LIST_LOADED,
    IP_LIST_LOADING,
    IP_PRICE_LOADED,
    IP_PRICE_LOADING,
    IPv6_STATUS_LOAD_ERROR,
    IPv6_STATUS_LOADED,
    IPv6_STATUS_LOADING,
    MAC_LIST_ERROR,
    MAC_LIST_LOADED,
    MAC_LIST_LOADING,
    PTR_LIST_LOADED,
    PTR_LIST_LOADING,
    SMTP_STATE_LOAD_ERROR,
    SMTP_STATE_LOADED,
    SMTP_STATE_LOADING,
    SOCIAL_ACCESS_INFO_ERROR,
    SOCIAL_ACCESS_INFO_LOADED,
    SOCIAL_ACCESS_INFO_LOADING,
    STATISTIC_ERROR,
    STATISTIC_LOADED,
    STATISTIC_LOADING,
} from '~/src/store/actionTypes/serviceSettings';

export type TConnectTypes = 'init' | 'connection' | 'disconnection';

export interface IServiceSettingsState {
    connectionType: IConnectionTypeState,
    ipPrice: {
        isLoading: boolean,
        ipPrice: IIpPrice,
    },
    ipList: {
        isLoading: boolean,
        ipList: ServiceSettingsIp[],
    },
    ptrZones: {
        isLoading: boolean,
        ptrZones: IPtrZones,
    },
    smtp: {
        isLoading: boolean,
        smtpBlockState: ESmtpBlockState | null,
    },
    ipv6: {
        isLoading: boolean,
        IPv6Status: EIPv6Status | null,
    },
    statistic: {
        isLoading: boolean,
        items: IStatistic[],
    },
    macList: {
        isLoading: boolean,
        items: IStatistic[],
    },
    socialAccessStatus: {
        isLoading: boolean,
        info: ISocialAccessData | null,
    },
    socialAccessConnect: {
        isLoading: boolean,
        type: TConnectTypes,
        message: string,
        isSuccess: boolean,
    },
}

interface IConnectionTypeState {
    isLoading: boolean,
    connectionType: EConnectionType,
}

export interface IAgreementLogin {
    login: string,
    terminalResourceId: number,
}

const initialValue: IServiceSettingsState = {
    connectionType: {
        isLoading: false,
        connectionType: EConnectionType.PPPoE,
    },
    ipPrice: {
        isLoading: false,
        ipPrice: {
            connect_price: '',
            discount_connect_price: '',
            discount_rent_price: '',
            rent_price: '',
        },
    },
    ipList: {
        isLoading: false,
        ipList: [],
    },
    ptrZones: {
        isLoading: false,
        ptrZones: {},
    },
    smtp: {
        isLoading: false,
        smtpBlockState: null,
    },
    ipv6: {
        isLoading: false,
        IPv6Status: null,
    },
    statistic: {
        isLoading: false,
        items: [],
    },
    macList: {
        isLoading: false,
        items: [],
    },
    socialAccessStatus: {
        isLoading: false,
        info: null,
    },
    socialAccessConnect: {
        isLoading: false,
        type: 'init',
        message: '',
        isSuccess: false,
    },
};
// достаем возвращаемое значения из ActionCreator
type TActions = ReturnType<InferValueTypes<typeof ActionCreators>>

const serviceSettingsReducer = (state = initialValue, action: THydrateAction | TActions): IServiceSettingsState => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                ...action.payload.serviceSettings,
            };
        case CONNECTION_TYPE_LOADING:
            return {
                ...state,
                connectionType: {
                    ...state.connectionType,
                    isLoading: true,
                },
            };
        case CONNECTION_TYPE_LOADED:
            return {
                ...state,
                connectionType: {
                    ...state.connectionType,
                    isLoading: false,
                    connectionType: action.payload,
                },
            };
        case IP_PRICE_LOADING:
            return {
                ...state,
                ipPrice: {
                    ...state.ipPrice,
                    isLoading: true,
                },
            };
        case IP_PRICE_LOADED:
            return {
                ...state,
                ipPrice: {
                    ...state.ipPrice,
                    isLoading: false,
                    ipPrice: action.payload,
                },
            };
        case IP_LIST_LOADING:
            return {
                ...state,
                ipList: {
                    ...state.ipList,
                    isLoading: true,
                },
            };
        case IP_LIST_LOADED:
            return {
                ...state,
                ipList: {
                    ...state.ipList,
                    isLoading: false,
                    ipList: action.payload,
                },
            };
        case PTR_LIST_LOADING:
            return {
                ...state,
                ptrZones: {
                    ...state.ptrZones,
                    isLoading: true,
                },
            };
        case PTR_LIST_LOADED:
            return {
                ...state,
                ptrZones: {
                    ...state.ptrZones,
                    isLoading: false,
                    ptrZones: action.payload,
                },
            };
        case IPv6_STATUS_LOADING:
            return {
                ...state,
                ipv6: {
                    ...state.ipv6,
                    isLoading: true,
                },
            };
        case IPv6_STATUS_LOAD_ERROR:
            return {
                ...state,
                ipv6: {
                    ...state.ipv6,
                    isLoading: false,
                    IPv6Status: EIPv6Status.error,
                },
            };
        case IPv6_STATUS_LOADED:
            return {
                ...state,
                ipv6: {
                    ...state.ipv6,
                    isLoading: false,
                    IPv6Status: action.payload,
                },
            };
        case SMTP_STATE_LOADING:
        case SMTP_STATE_LOAD_ERROR:
            return {
                ...state,
                smtp: {
                    ...state.smtp,
                    isLoading: true,
                },
            };
        case SMTP_STATE_LOADED:
            return {
                ...state,
                smtp: {
                    ...state.smtp,
                    isLoading: false,
                    smtpBlockState: action.payload,
                },
            };
        case STATISTIC_LOADING:
            return {
                ...state,
                statistic: {
                    ...state.statistic,
                    isLoading: true,
                },
            };
        case STATISTIC_ERROR:
            return {
                ...state,
                statistic: {
                    ...state.statistic,
                    isLoading: false,
                    items: [],
                },
            };
        case STATISTIC_LOADED:
            return {
                ...state,
                statistic: {
                    ...state.statistic,
                    isLoading: false,
                    items: action.payload,
                },
            };
        case MAC_LIST_LOADING:
            return {
                ...state,
                macList: {
                    ...state.macList,
                    isLoading: true,
                },
            };
        case MAC_LIST_LOADED:
            return {
                ...state,
                macList: {
                    ...state.macList,
                    isLoading: false,
                    items: action.payload,
                },
            };
        case MAC_LIST_ERROR:
            return {
                ...state,
                statistic: {
                    ...state.macList,
                    isLoading: false,
                    items: [],
                },
            };
        case SOCIAL_ACCESS_INFO_LOADING:
            return {
                ...state,
                socialAccessStatus: {
                    ...state.socialAccessStatus,
                    isLoading: true,
                },
            };
        case SOCIAL_ACCESS_INFO_LOADED:
            return {
                ...state,
                socialAccessStatus: {
                    ...state.socialAccessStatus,
                    isLoading: false,
                    info: action.payload,
                },
                socialAccessConnect: initialValue.socialAccessConnect,
            };
        case SOCIAL_ACCESS_INFO_ERROR:
            return {
                ...state,
                socialAccessStatus: {
                    ...state.socialAccessStatus,
                    isLoading: false,
                    info: null,
                },
            };
        case ADD_SOCIAL_ACCESS_LOADING:
            return {
                ...state,
                socialAccessConnect: {
                    ...state.socialAccessConnect,
                    isLoading: true,
                },
            };
        case ADD_SOCIAL_ACCESS_LOADED:
            return {
                ...state,
                socialAccessConnect: {
                    isLoading: false,
                    isSuccess: true,
                    type: action.payload.status,
                    message: action.payload.message,
                },
            };
        case ADD_SOCIAL_ACCESS_ERROR:
            return {
                ...state,
                socialAccessConnect: {
                    isLoading: false,
                    isSuccess: false,
                    type: action.payload.status,
                    message: action.payload.message,
                },
            };
        default:
            return state;
    }
};

export default serviceSettingsReducer;
